import axios from 'axios'

export const CheckResults = {
  methods: {
    async generateSecurityCode (form) {
      await axios.post(process.env.SERVER_URI + '/generate/confirmation_code', form).then((response) => {
        if (response.data === false) {
          this.$validator.errors.add({field: 'agreed', msg: 'Server issues!'})
          let field = this.$validator._resolveField('agreed')
          field.setFlags({invalid: true})
          //eslint-disable-next-line
          reject(new Error('Server issues!'))
        }
      }).catch(() => {
        this.$validator.errors.add({field: 'agreed', msg: 'Server issues!'})
        let field = this.$validator._resolveField('agreed')
        field.setFlags({invalid: true})
        //eslint-disable-next-line
        reject(new Error('Server issues!'))
      })
    },
    async getResults (firstName, lastName) {
      await axios.get(process.env.SERVER_URI + '/get/results/' + this.$store.state.results.site.site_code + '/' + this.$store.state.results.user.code + '/' + firstName + '/' + lastName).then((response) => {
        if (response.data === false) {
          this.$validator.errors.add({field: 'agreed', msg: 'Something went wrong!'})
          let field = this.$validator._resolveField('agreed')
          field.setFlags({invalid: true})
          // eslint-disable-next-line
          reject(new Error('Something went wrong!'))
        } else {
          this.$store.state.results.user.result = response.data
          this.$emit('result', response.data)
        }
      }).catch(() => {
        this.$validator.errors.add({field: 'agreed', msg: 'Server issues!'})
        let field = this.$validator._resolveField('agreed')
        field.setFlags({invalid: true})
        //eslint-disable-next-line
        reject(new Error('Server issues!'))
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/CheckResults.js